var map = {
	"./burial-document_1200.jpg": 12,
	"./burial-document_1600.jpg": 13,
	"./burial-document_2000.jpg": 14,
	"./burial-document_2400.jpg": 15,
	"./burial-document_800.jpg": 16,
	"./cover_1200.jpg": 17,
	"./cover_1600.jpg": 18,
	"./cover_2000.jpg": 19,
	"./cover_2400.jpg": 20,
	"./cover_800.jpg": 21,
	"./dorm_1200.jpg": 22,
	"./dorm_1600.jpg": 23,
	"./dorm_2000.jpg": 24,
	"./dorm_2400.jpg": 25,
	"./dorm_800.jpg": 26,
	"./registry-cover_1200.jpg": 27,
	"./registry-cover_1600.jpg": 28,
	"./registry-cover_2000.jpg": 29,
	"./registry-cover_2400.jpg": 30,
	"./registry-cover_800.jpg": 31,
	"./registry_1200.jpg": 32,
	"./registry_1600.jpg": 33,
	"./registry_2000.jpg": 34,
	"./registry_2400.jpg": 35,
	"./registry_800.jpg": 36,
	"./social.jpg": 37,
	"./state-press-2_1200.jpg": 38,
	"./state-press-2_1600.jpg": 39,
	"./state-press-2_2000.jpg": 40,
	"./state-press-2_2400.jpg": 41,
	"./state-press-2_800.jpg": 42,
	"./state-press-3_1200.jpg": 43,
	"./state-press-3_1600.jpg": 44,
	"./state-press-3_2000.jpg": 45,
	"./state-press-3_2400.jpg": 46,
	"./state-press-3_800.jpg": 47,
	"./state-press_1200.jpg": 48,
	"./state-press_1600.jpg": 49,
	"./state-press_2000.jpg": 50,
	"./state-press_2400.jpg": 51,
	"./state-press_800.jpg": 52
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;


//////////////////
// WEBPACK FOOTER
// ./src/media ^\.\/.*\.*
// module id = 81
// module chunks = 0